
    import '/home/ec2-user/Youlify-Design/components/icon/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["icon-demo-basic","icon-demo-two-tone","icon-demo-custom","icon-demo-iconfont","icon-demo-scripturl"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/icon/index.zh-CN.md?type=demo')
};